// Third Party Library
import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Drawer, message, Button } from "antd";

// Components
import { RemarkTextArea, RemarkLists, RemarkHeader } from "./components";

// Services Library
import { REDUX as REDUX_UTIL, TIME } from "../../services/util";

import * as REDUX_ACTION from "../../../v1/services/redux/actions";

const { reduxStoreWrapper } = REDUX_UTIL;

const DrawerRemark = ({ isOpen, setIsOpen, refid, statusData, memid }) => {
  const dispatch = useDispatch();

  // redux data used in this component
  const user = useSelector(reduxStoreWrapper("user"));
  const remarks = useSelector(reduxStoreWrapper("remark"));
  const loading = useSelector(reduxStoreWrapper("style.loading.remark"));

  // markup settings initialization
  const [messageApi, contextHolder] = message.useMessage();
  const [showTextArea, setShowTextArea] = useState(false);
  const [showEditTextArea, setShowEditTextArea] = useState(false);

  // 'edit' feature initialization
  const [edit, setEdit] = useState(false);
  const [index, setIndex] = useState(0);
  const [record, setRecord] = useState(null);

  // value initialization
  const [value, setValue] = useState(null);
  const [editValue, setEditValue] = useState(null);

  useEffect(() => {
    if (isOpen && refid) {
      messageApi.open({
        type: "loading",
        content: "Getting remarks...",
        duration: 0,
      });
      dispatch(
        REDUX_ACTION.v1_remark.get_remark_thru_refid_request(
          user.uid,
          refid,
          () => messageApi.destroy()
        )
      );
    }
    // return () => {};
  }, [dispatch, isOpen, refid]);

  // dataSource used in Remark List. Needs some adjustment
  let dataSource = Array.isArray(remarks)
    ? remarks.sort((a, b) => b.createdAt - a.createdAt)
    : [];


  const submitRemarkHDLR = (items, cb) =>
    dispatch(REDUX_ACTION.v1_remark.create_remark_request(items, memid, cb()));
  const updateRemarkHDLR = (items, cb) =>
    dispatch(REDUX_ACTION.v1_remark.update_remark_request(items, cb()));
  const deleteRemarkHDLR = (remid, cb) =>
    dispatch(REDUX_ACTION.v1_remark.delete_remark_request(remid, memid, cb()));

  // handleOkButton function will be triggered if OK button clicked
  const handleOkButton = () => {
    if (value === null) {
      message.error("Remark cannot be empty!");
      return;
    }
    
    // to show the loading popup
    messageApi.open({
      type: "loading",
      content: "Updating remark...",
      duration: 0,
    });

    const createItem = (value) => ({
      refid: refid,
      msg: value,
      createdBy: user.memid,
    });

    const updatedItem = (value) => ({
      remid: record.remid,
      updatedBy: user.memid,
      items: {
        ...record,
        msg: value,
      },
    });

    switch (edit) {
      // submit
      case false: {
        submitRemarkHDLR(createItem(value), () => messageApi.destroy);
        setShowTextArea(false);
        setValue(null);
        break;
      }
      // edit
      case true: {
        updateRemarkHDLR(updatedItem(editValue), () => messageApi.destroy);
        setShowEditTextArea(false);
        setEditValue(null);
        setEdit(false);
        setRecord(null);
        break;
      }

      default:
        break;
    }
  };

  const handleHide = (value, rec) => {
    messageApi.open({
      type: "loading",
      content: "Updating remark...",
      duration: 0,
    });
    const status = value === true ? 2 : 1;
    const updatedItem = {
      remid: rec.remid,
      updatedBy: user.memid,
      items: {
        ...rec,
        status: status,
      },
    };
    updateRemarkHDLR(updatedItem, () => messageApi.destroy);
  };

  // Simplify the reusable component
  const remarkListAttr = {
    dataSource,
    user,
    setIndex,
    setEdit,
    setEditValue,
    setShowEditTextArea,
    setRecord,
    messageApi,
    deleteRemarkHDLR,
    handleHide,
    remarks,
    TIME,
    edit,
    index,
    showEditTextArea,
    editValue,
    handleOkButton,
    loading,
    statusData,
  };
  const RemarkTextAreaAttr = {
    value,
    setValue,
    handleOkButton,
    setShowTextArea,
  };

  const drawerClose = () => {
    setIsOpen(false);
    dispatch(REDUX_ACTION.v1_remark.close_remark_success());
    setShowEditTextArea(false);
    setShowTextArea(false);
    setEdit(false);
  };

  // Main render
  return (
    <Drawer
      title={<RemarkHeader />}
      placement="right"
      closable={false}
      width={510}
      onClose={drawerClose}
      open={isOpen}
    >
      {contextHolder}

      <Button
        type="dashed"
        style={{ width: "100%" }}
        onClick={() => setShowTextArea(true)}
      >
        + Add Remark
      </Button>
      {/* 
                if Add Remark link clicked,
                it will shows the TextArea for adding new remark
            */}
      {showTextArea && <RemarkTextArea {...RemarkTextAreaAttr} />}

      {/* list of remarks of clicked account */}
      <RemarkLists {...remarkListAttr} />
    </Drawer>
  );
};

export default DrawerRemark;
